<template>
  <!-- <div class="border rounded mt-2"> -->
    <!-- <table class="table table-sm table-hover w-100">
      <thead>
        <tr>
          <th class="text-center" colspan="2">
            Master status
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-right w-35">
            <strong>Status:</strong>
          </td>
          <td class="text-left w-65">
            <select
              name="OrderStatus"
              class="form-control input-sm"
              v-model="order.masterStatus"
            >
              <option value="-1">Choose Order Status</option>
              <option value="PCA">Pending Client Approval</option>
              <option value="P">Pending</option>
              <option value="PI">Pending Invoice</option>
              <option value="H">Hold</option>
              <option value="C">Cancelled</option>
              <option value="S">Shipped</option>
              <option value="F">Finalized</option>
              <option value="R">Returned</option>
              <option value="WFC">Waiting For Credit</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Date filled:</strong>
          </td>
          <td class="text-left w-65">
            <a-date-picker
              style="width: 100%;"
              format="MM/DD/YYYY"
              :value="order.dateProcessed"
              @change="updateDateProcessed"
              id="dateFrom"
            />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Follow up:</strong>
          </td>
          <td class="text-left w-65">
            <b-form-checkbox
              v-model="order.followup"
              :true-value="1"
              :false-value="0"
              switch
            />
          </td>
        </tr>
        <tr>
          <td colspan="2">
            
          </td>
        </tr>
      </tbody>
    </table> -->
    <button
      type="button"
      style="display: block; margin: 0 auto;"
      class="btn btn-primary"
      @click="submit"
      :disabled="order.ret_points === true"
      :title="order.ret_points ? 'Order is refunded' : ''"
    >
      Refund Order
    </button>
  <!-- </div> -->
</template>

<script>
import moment from "moment";
export default {
  name: "MasterStatus",
  methods: {
    updateDateProcessed(date, datestring) {
      this.order.dateProcessed = datestring;
    },
    submit() {
      this.$store.commit("orderDetails/SET_LOADING_FOR_STATUS", true);
      const changeOrderStatusRequest = {
        orderId: this.order.orderId,
        orderNumber: this.order.orderNumber,
        callTag: this.order.callTag !== "0" ? true : false,
        nla: this.order.nla,
        labelReq: this.order.labelReq,
        labelReqDate:
          this.order.labelReqDate !== "" && this.order.labelReqDate !== null
            ? this.order.labelReqDate
            : "",
        replaceReq: this.order.replaceReq,
        backordered: this.order.backordered,
        followup: this.order.followup === true ? 1 : 0,
        dateProcessed:
          this.order.dateProcessed !== "" && this.order.dateProcessed !== null
            ? moment(this.order.dateProcessed).format("YYYY-MM-DD") +
              "T00:00:00.000Z"
            : "",
        backOrderDate:
          this.order.backOrderDate !== "" && this.order.backOrderDate !== null
            ? moment(this.order.backOrderDate).format("YYYY-MM-DD") +
              "T00:00:00.000Z"
            : "",
        ret_by_name: this.order.ret_by_name,
        return_qty: this.order.quantity ? this.order.quantity : 0,
        return_reason:
          this.order.ret_reason === "-1" ? "" : this.order.ret_reason,
        ret_points: this.order.ret_points,
        points_return_by: this.order.ret_by_name,
        status: this.order.status === "-1" ? "" : this.order.status,
        orderstatus:
          this.order.masterStatus === "-1" ? "" : this.order.masterStatus,
      };
      this.$store
        .dispatch("orderDetails/updateOrderStatus", changeOrderStatusRequest)
        .then((data) => {
          alert(data.message);
        })
        .finally(() => {
          this.$store.commit("orderDetails/SET_LOADING_FOR_STATUS", false);
        });
    },
  },
  computed: {
    order() {
      return this.$store.state.orderDetails.orderData;
    },
  },
};
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}
.w-35 {
  width: 35%;
}
.w-65 {
  width: 65%;
}
.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
  margin-left: -1.5em !important;
}
table {
  margin-bottom: 0px;
  border: solid grey 0.5px;
}
td {
  border: solid grey 0.5px;
}
</style>
